import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

import { fidelityTransactionTypeSchema } from "./fidelity-transaction";

/**
 * DTO historique de création, conservé pour compatibilité.
 *
 * Les nouveaux services calculeront eux-mêmes les points
 * et les soldes dans une transaction.
 *
 * Ce DTO ne doit pas servir à autoriser un utilisateur
 * à choisir librement son solde ou ses récompenses.
 */
const createFidelityTransactionSchema = z.object({
  accountId: z.string().min(1),
  type: fidelityTransactionTypeSchema,
  points: z.number(),
  balanceBefore: z.number(),
  balanceAfter: z.number(),
});

export class CreateFidelityTransactionDto extends createZodDto(createFidelityTransactionSchema) {}
